'use client';

import Image from 'next/image';
import { useIntl } from 'react-intl';
import appIconSrc from './app-icon.svg';
import appIconCircle from './app-icon-circle.svg';

type Props = {
  className?: string;
  size: number;
  shape?: 'circle' | 'square';
};

// https://www.figma.com/file/9Y1n3VoMJAcTGPe82bvySj/Denali-Components?type=design&node-id=5003-58164&mode=dev
export default function AppIcon({ className, size, shape = 'square' }: Props) {
  const intl = useIntl();

  return (
    <Image
      alt={intl.formatMessage({ defaultMessage: 'AllTrails logo' })}
      className={className}
      height={size}
      src={shape === 'square' ? appIconSrc : appIconCircle}
      width={size}
    />
  );
}
